import { Box, Typography, useTheme } from '@mui/material'

export function SaveChangesButton({...params}){

    let theme = useTheme()
    let saveButtonFontColor = theme.palette.ChannelPage.subheader.fontfilled

    let handleSaveAllChangesClick = params.handleSaveAllChangesClick
    let updatedFieldsCountState = params.updatedFieldsCountState

    let saveButtonState = params.saveButtonState
    let setSaveButtonState = params.setSaveButtonState

    const handleButtonHover = (event) => {
        event.preventDefault()
        setSaveButtonState('hover')
    }

    const handleButtonMouseOut = (event) => {
        event.preventDefault()
        setSaveButtonState('default')
    }

    let buttonColor = ''
    let buttonOpacity = ''
    if (updatedFieldsCountState === 0){
        buttonColor = '#06569D'
        buttonOpacity = '50%'
    }

    else if (updatedFieldsCountState > 0){
        if (saveButtonState === 'default') buttonColor = '#06569D'
        else if (saveButtonState === 'hover') buttonColor = '#108DF9'
        buttonOpacity = '100%'
    }
    

    return (
        <Box alignSelf={'center'} height={'35px'} width={'139px'} padding={'5px 10px'} sx={{backgroundColor: buttonColor, opacity: buttonOpacity}} 
            onClick={handleSaveAllChangesClick}
            onMouseOut={(event) => handleButtonMouseOut(event)} 
            onMouseOver={(event) => handleButtonHover(event)}
        >
            <Typography align={'center'} color={saveButtonFontColor} fontSize={'18px'} fontWeight={400}>Save Changes</Typography>
        </Box>
    )
}
